import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { invokeApi } from "../../../../../../bl_libs/invokeApi";
import Feadback from "./Feadback";
function LeaveFeedback(props) {
  const { requestData, fetchRequestDetails } = props;
  const { id, final_amount, discount, request_type } = requestData.request;
  const [filters, setFilters] = useState({
    comments: "",
    tip: 0,
    ratting: "",
    tip_amount: "",
  });

  const handleRatting = (ratting) => {
    setFilters({ ...filters, ratting: ratting });
  };

  const submitFeedback = () => {
    let requestObj = {
      path: "/app_api/add_feedback",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
      rating: `${filters.ratting}`,
      comment: `${filters.comments}`,
      tip: `${
        filters.tip === "other"
          ? filters.tip_amount
          : discount === 0
          ? //if discount is 0
            (parseInt(final_amount) * filters.tip) / 100
          : //if discount is not 0
            (parseInt(final_amount * (1 - parseInt(discount) / 100)) *
              filters.tip) /
            100
      }`,
    };

    console.log(postData);

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        fetchRequestDetails("loading");
      } else {
      }
    });
  };
  return (
    <>
      <div className="row pt-4 pb-3">
        <div className="col-12">
          <button
            data-toggle="modal"
            data-target="#feedback"
            className="custom-buton custom-buton-large w-100"
          >
            Leave feedback
          </button>
        </div>
      </div>
      <Feadback
        filters={filters}
        setFilters={setFilters}
        handleRatting={handleRatting}
        id={id}
        submitFeedback={submitFeedback}
        request_type={request_type}
      />
    </>
  );
}

export default withRouter(LeaveFeedback);
